
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SearchSuppliersParameters.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SearchSuppliersParameters.ts

import {SupplierStatut } from "./SupplierStatut";
export class SearchSuppliersParameters {

  // string SupplierName
  public SupplierName?: string=null;

  // string UniqueId
  public UniqueId?: string=null;

  // string NumTiers
  public NumTiers?: string=null;

  // string PostalCod
  public PostalCod?: string=null;

  // int? CountryId
  public CountryId?: number=null;

  // int[] RegionIds
  public RegionIds: number[]=[];

  // int[] DepartmentIds
  public DepartmentIds: number[]=[];

  // string GroupName
  public GroupName?: string=null;

  // string InternalContactLastname
  public InternalContactLastname?: string=null;

  // SupplierStatut[] Statuts
  public Statuts: SupplierStatut[]=[];

  // string StatutsIds
  public StatutsIds?: string=null;
}